export default __webpack_public_path__ + "static/media/image-main-2-w@2x.a5d57369.webp";